/* tslint:disable: max-classes-per-file */
export { MarkdownComponent, MarkdownConfig, MarkdownModule, MarkdownService } from './markdown';



// WEBPACK FOOTER //
// ./src/index.ts